<template>
  <v-container class="pt-12 px-12">
    <v-row class="mb-6" align="center" justify="space-between">
      <v-col cols="12" md="6">
        <div style="font-family: 'montserrat-bold'; font-size: 28px; color: primary;">
          Lista de facturas
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Aquí puedes revisar el estatus completo de todas las facturas disponibles.
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-card
          class="py-6 px-6"
          style="background-color: #f5f5f5; border-radius: 24px; width: 100%; max-width: 550px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);"
        >
          <div class="d-flex justify-space-between align-center mb-3" style="flex-wrap: wrap;">
            <div style="font-family: 'montserrat-semibold'; font-size: 22px; white-space: nowrap;">Crédito utilizado</div>
            <div style="font-family: 'montserrat-semibold'; font-size: 14px; white-space: nowrap; ">
              {{ "$ " + formatMoney(creditoUsado) + " USD" }} / {{ "$ " + formatMoney(creditoTotal) + " USD" }}
            </div>
          </div>

          <div style="overflow: hidden; border-radius: 100px;">
            <v-progress-linear
              :value="creditoPorcentaje"
              height="8"
              color="primary"
              background-color="#dcdcdc"
              rounded
            />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-6" align="center" justify="space-between">
      <v-col class="d-flex">
        <div style="width: 286px;">
          <v-text-field
            v-model="busqueda"
            placeholder="Buscar factura"
            clearable
            hide-details
            outlined
            style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
            prepend-inner-icon="mdi-magnify"
          />
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end">
        <!-- <v-btn
          color="primary"
          class="white--text"
          rounded
          elevation="4"
          style="text-transform: none; font-family: 'montserrat-semibold';"
          @click="dialogCreateInvoice = true, factura = { numero: '', cedenteId: '', deudor: '', monto: 0, fechaEmision: '', fechaVencimiento: '', archivos: [] }"
        >
          Agregar factura
        </v-btn> -->
      </v-col>
    </v-row>

    <v-expansion-panels multiple accordion>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de validar ({{ invoicesPorEstado['subida']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['subida']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <!-- <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="dialogValidateInvoice = true; facturaSeleccionada = factura"
              >
                {{ "Validar" }}
              </v-btn>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de aprobar ({{ invoicesPorEstado['validada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['validada']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <!-- <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="dialogAprobarInvoice = true; facturaSeleccionada = factura"
              >
                {{ "Aprobar" }}
              </v-btn>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de adelantar ({{ invoicesPorEstado['aprobada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['aprobada']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <!-- <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="dialogAdelantarInvoice = true; facturaSeleccionada = factura, adelanto = {}"
              >
                {{ "Adelantar" }}
              </v-btn>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de cobrar ({{ invoicesPorEstado['adelantada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['adelantada']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div v-if="factura.fecha_vencimiento" :style="{fontSize: '13px', color: isVencida(factura.fecha_vencimiento) ? 'red' : '#777'}">
                Fecha de vencimiento: {{ formatDate(factura.fecha_vencimiento) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <!-- <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="dialogCobrarFactura = true; facturaSeleccionada = factura, cobro = {}"
              >
                {{ "Cobrar" }}
              </v-btn>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de compensar ({{ invoicesPorEstado['compensacion']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['compensacion']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
              
            </v-col>

            <!-- <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="dialogLiquidarFactura = true; facturaSeleccionada = factura"
              >
                {{ "Liquidar" }}
              </v-btn>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de liquidar ({{ invoicesPorEstado['cobrada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['cobrada']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
              
            </v-col>

            <!-- <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="dialogLiquidarFactura = true; facturaSeleccionada = factura"
              >
                {{ "Liquidar" }}
              </v-btn>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Liquidadas ({{ invoicesPorEstado['liquidada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['liquidada']"
            :key="factura.external_invoice_id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.external_invoice_id }}
              </div>
              <div style="font-size: 13px; color: #000; font-family: 'montserrat-bold';">
                Deudor: {{ factura.deudor_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: ${{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="primary"
                class="white--text"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="abrirDetalle(factura)"
              >
                {{ "Ver Detalle" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialogCreateInvoice" max-width="650px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <v-form ref="formNew" lazy-validation v-on:submit.prevent>
          <!-- Título -->
          <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
            Agregar Factura
          </div>

          <v-divider class="my-4" />

          <!-- Información básica -->
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                v-model="factura.external_invoice_id"
                label="PO del Deudor"
                outlined
                style="border-radius: 10px;"
                dense
                class="mb-2"
                hide-details
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="factura.reference"
                label="Referencia interna (opcional)"
                style="border-radius: 10px;"
                outlined
                class="mb-2"
                hide-details
                dense
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-select
                v-model="factura.cedenteId"
                :items="cedentes"
                item-text="empresa"
                item-value="enterpriseId"
                label="Cedente"
                outlined
                :rules="[rules.required]"
                dense
                hide-details
                style="border-radius: 10px;"
                @change="cargarDeudores(factura.cedenteId)"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="factura.deudor"
                :items="deudores"
                return-object
                item-text="empresa"
                item-value="enterpriseId"
                label="Deudor"
                outlined
                dense
                :rules="[rules.required]"
                hide-details
                style="border-radius: 10px;"
                required
              />
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <v-row dense>
            <v-col cols="6">
              <v-menu
                ref="menuEmision"
                v-model="menuEmision"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="factura.fechaEmision"
                    label="Fecha de Emisión"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                    style="border-radius: 10px;"
                    class="mb-2"
                    outlined
                    hide-details
                    dense
                  />
                </template>
                <v-date-picker v-model="factura.fechaEmision" @input="menuEmision = false" />
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu
                ref="menuVencimiento"
                v-model="menuVencimiento"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="factura.fechaVencimiento"
                    label="Fecha de Vencimiento"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    style="border-radius: 10px;"
                    outlined
                    :rules="[rules.required]"
                    hide-details
                    class="mb-2"
                    dense
                  />
                </template>
                <v-date-picker v-model="factura.fechaVencimiento" @input="menuVencimiento = false" />
              </v-menu>
            </v-col>
          </v-row>

          <!-- Monto y Fechas -->
          <v-row dense style="align-items: center;">
            <v-col cols="6">
              <v-text-field
                v-model.number="factura.monto"
                label="Monto total (USD)"
                type="number"
                outlined
                :rules="[rules.required]"
                dense
                hide-details
                style="border-radius: 10px;"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-card
                flat
                class="d-flex align-center justify-center flex-column py-2"
                style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
              >
                <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                  Monto total (USD)
                </div>
                <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                  ${{ formatMoney(factura.monto) }} USD
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <!-- Documentos adjuntos -->
          <div style="font-family: 'montserrat-semibold'; font-size: 14px;" class="mb-2">Documentos adjuntos</div>

          <v-row dense>
            <v-col
              v-for="(archivo, index) in factura.archivos"
              :key="index"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
                <div class="d-flex flex-column">
                  <span style="font-weight: 600;">{{ archivo.name }}</span>
                  <span class="text--secondary text-caption">{{ (archivo.size / 1024).toFixed(1) }} KB</span>
                </div>
                <v-btn icon @click="eliminarArchivo(index)">
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card
                class="pa-3 d-flex align-center justify-center"
                outlined
                style="cursor: pointer; border: 2px dashed #1876d2;"
                @click="$refs.uploader.click()"
              >
                <v-icon size="32" color="primary">mdi-plus</v-icon>
                <span class="ml-2 font-weight-medium">Agregar documento</span>
                <input
                  type="file"
                  accept=".pdf,.xml"
                  style="display: none"
                  ref="uploader"
                  @change="agregarArchivoManual"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <!-- Acciones -->
          <v-card-actions>
            <v-btn 
              block
              large
              color="primary"
              class="white--text mt-2"
              style="border-radius: 10px; text-transform: none; font-weight: 600;" 
              @click="createInvoice()"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      creditoUsado: 0,
      creditoTotal: 0,
      creditoPorcentaje: 0,
      dialogCreateInvoice: false,
      dialogActiv: false,
      facturaSeleccionada: null,
      showTicket: false,
      dialogAprobarInvoice: false,
      showContract: false,
      dialogValidateInvoice: false,
      dialogAdelantarInvoice: false,
      dialogCobrarFactura: false,
      dialogLiquidarFactura: false,
      liquidacion: {
        monto: null,
        referencia: '',
        comprobante: null,
        nota: ''
      },
      cobro: {
        origen: '',
        referencia: '',
        comprobante: null,
        nota: ''
      },
      adelanto: {
        monto: null,
        origen: '',
        comprobante: null,
      },
      cuentaDestino: {
        banco: 'Banco Nacional',
        numero: '1234567890',
        clabe: '012345678901234567'
      },
      busqueda: '',
      invoices: [],
      cedentes: [],
      deudores: [],
      facturaSeleccionada: null,
      factura: {
        external_invoice_id: "",
        reference: "",
        deudor: null,
        monto: null,
        fechaEmision: null,
        fechaVencimiento: null,
        archivos: []
      },
      menuEmision: false,
      menuVencimiento: false,
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
    };
  },
  computed: {
    montoSugerido() {
      const pagoDeudor = this.facturaSeleccionada.monto_cobrado || 0;
      const adelantos = (this.facturaSeleccionada.monto_adelantado) || 0;
      const interes = (this.facturaSeleccionada.monto_total || 0) * 0.025;
      
      const diasMoratorios = Math.max(0, this.facturaSeleccionada.dias_moratorios);
      const interesMoratorio = (this.facturaSeleccionada.monto_total || 0) * (diasMoratorios / 30 * 0.025);

      return Math.max(pagoDeudor - adelantos - interes - interesMoratorio);
    },
    invoicesPorEstado() {
      if (!Array.isArray(this.invoices)) return {};

      const query = this.busqueda ? this.busqueda.toLowerCase() : null;

      return this.invoices.reduce((acc, factura) => {
        // 🔍 Aplica el filtro
        const matchesSearch = !query || 
          String(factura.external_invoice_id).toLowerCase().includes(query) ||
          String(factura.monto_total).includes(query) || 
          (factura.cedente_name && factura.cedente_name.toLowerCase().includes(query)) || 
          (factura.deudor_name && factura.deudor_name.toLowerCase().includes(query));

        if (!matchesSearch) return acc;

        const estado = factura.estatus || 'SIN_ESTADO';
        if (!acc[estado]) {
          acc[estado] = [];
        }
        acc[estado].push(factura);
        return acc;
      }, {});
    },
  },
  methods: {
    async getInvoices() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/client/cedente`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.invoices = response.data.factoringInvoices || [];
        this.creditoTotal = response.data.resumenLinea.linea_total_autorizada || 0;
        this.creditoUsado = response.data.resumenLinea.linea_usada || 0;
        this.creditoPorcentaje = this.creditoTotal ? (this.creditoUsado / this.creditoTotal) * 100 : 0;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCedentes() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/cedentes`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.cedentes = response.data.cedentes || [];
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async cargarDeudores() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/client/getDebtors`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.deudores = response.data.deudores || [];
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async createInvoice() {
      const isValid = await this.$refs.formNew.validate();

      if (!isValid) {
        this.mixError('Revisa los campos obligatorios antes de continuar');
        return;
      }

      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('external_invoice_id', this.factura.external_invoice_id);
        formData.append('reference', this.factura.reference || '');
        formData.append('contractId', this.factura.deudor.contractId);
        formData.append('monto', this.factura.monto);
        formData.append('moneda', 'USD');
        formData.append('fechaEmision', this.factura.fechaEmision);
        formData.append('fechaVencimiento', this.factura.fechaVencimiento);

        this.factura.archivos.forEach(file => {
          formData.append('archivos', file);
        });

        const response = await DB.post(`${URI}/api/v1/en/factoringInvoices/admin/invoices`, formData, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : '',
            'Content-Type': 'multipart/form-data'
          }
        });

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura creada correctamente');
        this.dialogCreateInvoice = false;
        this.factura = {
          external_invoice_id: "",
          reference: "",
          deudor: null,
          monto: null,
          fechaEmision: null,
          fechaVencimiento: null,
          archivos: []
        };
        this.getInvoices();
      } catch (error) {
        this.isLoading = false;
        this.mixError(error.response?.data?.message, error.response?.status);
      }
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
    async validateInvoice(invoiceId) {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/validate/${invoiceId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura actualizada correctamente');
        this.dialogValidateInvoice = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async approveInvoice(invoiceId) {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/approve/${invoiceId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura actualizada correctamente');
        this.dialogAprobarInvoice = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async adelantarFactura(invoiceId) {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('amount', this.adelanto.monto);
        formData.append('origin', this.adelanto.origen);
        formData.append('destination', this.adelanto.destino || '');
        formData.append('reference', this.adelanto.referencia || '');
        formData.append('note', this.adelanto.nota || '');

        if (this.adelanto.comprobante) {
          formData.append('document', this.adelanto.comprobante);
        }

        const response = await DB.post(
          `${URI}/api/v1/en/factoringInvoices/advance/${invoiceId}`,
          formData,
          {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura adelantada correctamente');
        this.dialogAdelantarInvoice = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async cobrarFactura(invoiceId) {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('amount', (this.facturaSeleccionada.monto_total - this.facturaSeleccionada.ajuste));
        formData.append('origin', this.cobro.origen);
        formData.append('destination', this.cuentaDestino.banco || '');
        formData.append('reference', this.cobro.referencia || '');
        formData.append('note', this.cobro.nota || '');

        if (this.cobro.comprobante) {
          formData.append('document', this.cobro.comprobante);
        }

        const response = await DB.post(
          `${URI}/api/v1/en/factoringInvoices/collect/${invoiceId}`,
          formData,
          {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura cobrada correctamente');
        this.dialogCobrarFactura = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async liquidarFactura(invoiceId) {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('amount', this.liquidacion.monto);
        formData.append('origin', this.liquidacion.origen);
        formData.append('destination', this.cuentaDestino.banco || '');
        formData.append('reference', this.liquidacion.referencia || '');
        formData.append('note', this.liquidacion.nota || '');

        if (this.liquidacion.comprobante) {
          formData.append('document', this.liquidacion.comprobante);
        }

        const response = await DB.post(
          `${URI}/api/v1/en/factoringInvoices/liquidar/${invoiceId}`,
          formData,
          {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura liquidada correctamente');
        this.dialogLiquidarFactura = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    agregarArchivoManual(event) {
      const archivo = event.target.files[0];
      if (archivo) {
        this.factura.archivos.push(archivo);
      }
      // resetear input para poder volver a subir el mismo archivo si lo desea
      event.target.value = null;
    },
    eliminarArchivo(index) {
      this.factura.archivos.splice(index, 1);
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    isVencida(fecha) {
      const hoy = new Date();
      const vencimiento = new Date(fecha);
      return vencimiento < hoy;
    },
    abrirDetalle(factura) {
      this.$router.push({
        name: 'FacturaDeudorDetalle',
        params: { invoiceId: factura.id }
      });
    },
  },
  beforeMount() {
    this.getInvoices();
    this.cargarDeudores()
  },
};
</script>

<style>
  .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
  }
</style>